import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-welcomepage-dialog',
  templateUrl: './welcomepage-dialog.component.html',
  styleUrls: ['./welcomepage-dialog.component.scss']
})
export class WelcomepageDialogComponent {
  @Input() isOpen: boolean = false;
  @Output() cancel = new EventEmitter<void>();
  @Output() continuePam = new EventEmitter<void>();

  onCancel() { this.cancel.emit(); }
  onContinue() { this.continuePam.emit(); }
}
